const SpacingsValues = Object.freeze({
    '--spacing-0': '0px',
    '--spacing-2': '2px',
    '--spacing-4': '4px',
    '--spacing-6': '6px',
    '--spacing-8': '8px',
    '--spacing-10': '10px',
    '--spacing-12': '12px',
    '--spacing-16': '16px',
    '--spacing-24': '24px',
    '--spacing-32': '32px',
    '--spacing-40': '40px',
    '--spacing-44': '44px',
    '--spacing-48': '48px',
    '--spacing-56': '56px',
    '--spacing-64': '64px',
    '--spacing-72': '72px',
});
const Spacings = {
    s0: 'var(--spacing-0)',
    s2: 'var(--spacing-2)',
    s4: 'var(--spacing-4)',
    s6: 'var(--spacing-6)',
    s8: 'var(--spacing-8)',
    s10: 'var(--spacing-10)',
    s12: 'var(--spacing-12)',
    s16: 'var(--spacing-16)',
    s24: 'var(--spacing-24)',
    s32: 'var(--spacing-32)',
    s40: 'var(--spacing-40)',
    s44: 'var(--spacing-44)',
    s48: 'var(--spacing-48)',
    s56: 'var(--spacing-56)',
    s64: 'var(--spacing-64)',
    s72: 'var(--spacing-72)',
};

export { Spacings, SpacingsValues };
